export default function loadingBarConfig(cfpLoadingBarProvider) {
    cfpLoadingBarProvider.latencyThreshold = 100;
    cfpLoadingBarProvider.spinnerTemplate = require('./angular-loading-bar.template.html');
}
loadingBarConfig.$inject = ['cfpLoadingBarProvider'];
